<template>
  <div class="register-page">
    <div class="register-container">
      <span class="back-link" @click="$router.push('/')">← 返回首页</span>
      
      <h1 class="page-title">注册</h1>
      
      <div class="form-section">
        <div class="form-group">
          <label class="form-label">手机号</label>
          <input 
            type="tel" 
            class="form-input" 
            v-model="formData.username" 
            placeholder="请输入手机号"
            :disabled="loading"
          />
        </div>
        
        <div class="form-group">
          <label class="form-label">密码</label>
          <input 
            type="password" 
            class="form-input" 
            v-model="formData.password" 
            placeholder="6-20位字母或数字"
            :disabled="loading"
          />
        </div>
        
        <div class="form-group">
          <label class="form-label">确认密码</label>
          <input 
            type="password" 
            class="form-input" 
            v-model="formData.confirmPassword" 
            placeholder="再次输入密码"
            :disabled="loading"
            @keyup.enter="handleRegister"
          />
        </div>
        
        <div class="form-checkbox">
          <input type="checkbox" id="agree" v-model="agreeTerms" />
          <label for="agree">我已阅读并同意 <a @click.prevent="$router.push('/page/agreement')">用户协议</a></label>
        </div>
        
        <button 
          type="button" 
          class="btn-submit" 
          @click="handleRegister"
          :disabled="loading"
        >
          {{ loading ? '注册中...' : '注册' }}
        </button>
        
        <p class="form-footer">
          已有账号？<a @click="$router.push('/login')">立即登录</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { userRegister } from '@/api/index.js'

export default {
  name: 'RegisterPage',
  data() {
    return {
      formData: {
        username: '',
        password: '',
        confirmPassword: ''
      },
      agreeTerms: false,
      loading: false
    }
  },
  methods: {
    async handleRegister() {
      // 表单验证
      if (!this.formData.username) {
        this.$message.warning('请输入手机号')
        return
      }
      
      // 简单的手机号格式验证
      const phoneReg = /^1[3-9]\d{9}$/
      if (!phoneReg.test(this.formData.username)) {
        this.$message.warning('请输入正确的手机号格式')
        return
      }
      
      if (!this.formData.password) {
        this.$message.warning('请输入密码')
        return
      }
      
      if (this.formData.password.length < 6 || this.formData.password.length > 20) {
        this.$message.warning('密码长度应为6-20位')
        return
      }
      
      if (this.formData.password !== this.formData.confirmPassword) {
        this.$message.warning('两次输入的密码不一致')
        return
      }
      
      if (!this.agreeTerms) {
        this.$message.warning('请阅读并同意用户协议')
        return
      }
      
      this.loading = true
      try {
        const result = await userRegister({
          username: this.formData.username,
          password: this.formData.password
        })
        
        if (result.code === 1) {
          this.$message.success('注册成功，即将跳转到首页')
          // 保存token到localStorage
          localStorage.setItem('token', result.data.userinfo.token)
          localStorage.setItem('userInfo', JSON.stringify(result.data.userinfo))
          
          // 跳转到首页
          setTimeout(() => {
            this.$router.push('/')
          }, 1000)
        } else {
          this.$message.error(result.msg || '注册失败')
        }
      } catch (error) {
        console.error('注册失败:', error)
        this.$message.error('注册失败，请稍后重试')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.register-page {
  min-height: 100vh;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 24px;
}

.register-container {
  width: 100%;
  max-width: 360px;
}

.back-link {
  font-size: 14px;
  color: #666;
  cursor: pointer;
  display: inline-block;
  margin-bottom: 40px;
  transition: color 0.2s;
}

.back-link:hover {
  color: #111;
}

.page-title {
  font-size: 32px;
  font-weight: 800;
  color: #111;
  margin: 0 0 40px 0;
}

.form-section {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-label {
  font-size: 14px;
  font-weight: 500;
  color: #111;
}

.form-input {
  width: 100%;
  padding: 14px 16px;
  font-size: 15px;
  border: 1px solid #ddd;
  outline: none;
  transition: border-color 0.2s;
  box-sizing: border-box;
}

.form-input:focus {
  border-color: #111;
}

.form-checkbox {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #666;
}

.form-checkbox input {
  width: 16px;
  height: 16px;
  cursor: pointer;
}

.form-checkbox a {
  color: #111;
  text-decoration: underline;
  cursor: pointer;
}

.btn-submit {
  width: 100%;
  padding: 14px;
  font-size: 15px;
  font-weight: 600;
  color: #fff;
  background: #111;
  border: none;
  cursor: pointer;
  transition: opacity 0.2s;
  margin-top: 8px;
}

.btn-submit:hover:not(:disabled) {
  opacity: 0.8;
}

.btn-submit:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.form-footer {
  font-size: 14px;
  color: #666;
  text-align: center;
  margin: 24px 0 0 0;
}

.form-footer a {
  color: #111;
  font-weight: 500;
  cursor: pointer;
  text-decoration: underline;
  margin-left: 4px;
}
</style>
